export default __webpack_public_path__ + "static/vodafone-faded.url-0e5847880a0aa43abe3c526705ebe579.svg";